import React from 'react'
import { Dialog } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ModalDialog } from '@sistemiv/s-components'
import { useTranslation } from 'react-i18next'
import ReactMarkdown from 'react-markdown'

type DocumentationModalProps = {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  markdown: string
}

const DocumentationModal: React.FC<DocumentationModalProps> = ({ open, setOpen, markdown }) => {
  const { t } = useTranslation()
  return (
    <ModalDialog isOpen={open} setOpen={setOpen} className='!max-w-xl my-5'>
      <Dialog.Title as='h3' className='leading-6 text-lg flex justify-between'>
        {t('documentation')}
        <button onClick={() => setOpen(false)}>
          <XMarkIcon className='w-5 h-5 stroke-gray-500' />
        </button>
      </Dialog.Title>

      <div className='prose'>
        <ReactMarkdown>{markdown}</ReactMarkdown>
      </div>
    </ModalDialog>
  )
}

export default DocumentationModal
